import React from 'react';
import { connect } from 'react-redux';

import { toggleModalWithTimer, toggleSpinner, updateMessages } from 'apps/auth/actions/appAction';
import { setExtra } from 'apps/auth/actions/extraAction';
import { updatePageMessages } from 'apps/auth/actions/messageAction';
import PopupButton from 'apps/auth/components/common/Popup/PopupButton';
import SimplePopup from 'apps/auth/components/common/Popup/SimplePopup';
import { AUTH_EMAIL_CONFIRM_ACTION, AUTH_PROFILE_CHANGE_EMAIL } from 'apps/auth/constants/UrlConstants';
import { apiFetchData } from 'apps/auth/helpers/api';
import { resolveArguments } from 'apps/auth/helpers/utils';
import { useExtra, usePageMessages } from 'apps/auth/hooks/selectors';

const ConfirmEmailPopup = (props) => {
    const { userFlags, isCanChangeEmail, email, show_email_promocode_page: showPromoCode } = useExtra();
    const { emailPopupDisclaimerText, emailPopupEmailButton, emailPopupChangeEmail } = usePageMessages();
    const { cards_and_accounts_allowed: hasGA, libre_allowed } = userFlags || {};
    const canChangeEmail = !hasGA && !libre_allowed && isCanChangeEmail;

    const confirmEmail = (e) => {
        if (showPromoCode) {
            e.preventDefault();
        }
        props.popupRef.current?.close();
        props.toggleSpinner(true);
        apiFetchData(AUTH_EMAIL_CONFIRM_ACTION)
            .then((json) => {
                if (json) {
                    if (json.messageBodyMessages) {
                        props.updateMessages(json.messageBodyMessages);
                    }
                    if (json.messages) {
                        props.updatePageMessages(json.messages);
                    }
                    if (json.extra) {
                        if (json.extra.checkInbox && json.messages?.successMessage) {
                            props.toggleModalWithTimer(true, json.messages.successMessage, () => {
                                props.toggleModalWithTimer(false, '', false);
                            });
                        }
                        props.setExtra(json.extra);
                    }
                }
                props.toggleSpinner(false);
            })
            .catch(() => {
                props.toggleSpinner(false);
            });
    };

    return (
        <SimplePopup text={resolveArguments(emailPopupDisclaimerText, email)} popupRef={props.popupRef}>
            <PopupButton href={showPromoCode ? AUTH_EMAIL_CONFIRM_ACTION : null} iconName="check" text={emailPopupEmailButton} onClick={confirmEmail} />
            {canChangeEmail && (
                <PopupButton
                    href={AUTH_PROFILE_CHANGE_EMAIL}
                    iconName="retry"
                    text={emailPopupChangeEmail}
                    onClick={() => {
                        props.toggleSpinner(true);
                        props.popupRef.current?.close();
                    }}
                />
            )}
        </SimplePopup>
    );
};

export default connect(null, { updateMessages, toggleSpinner, updatePageMessages, setExtra, toggleModalWithTimer })(ConfirmEmailPopup);
